export default __webpack_public_path__ + "static/media/trust.67c74011.svg";